import React from 'react'
import { Link } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa6";

import File1 from "./../../assets/pdf/Car-Motorcycle-ScooterMopedCycleAdvanceForm_1.pdf";
import File2 from "./../../assets/pdf/WheatAdvanceForm.pdf";
import File3 from "./../../assets/pdf/ProformaForHouseBuildingAdvance_1.pdf";
import File4 from "./../../assets/pdf/MarriageAdvanceProforma.pdf";
import File5 from "./../../assets/pdf/ComputerAdvanceProforma.pdf";
import File6 from "./../../assets/pdf/EducationAllowanceProforma.pdf";
const Forms = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Forms & Procedures </h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
    >
       <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>
                  <span>S.No</span>
                </th>
                <th>
                  <span>Subject</span>
                </th>
                
                <th>
                  <span>
                    Document{" "}
                    <span style={{ fontSize: "12px" }}>(pdf, English)</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>1</span>
                </td>
                <td>
                  <strong>
                  APPLICATION FORM FOR CAR/MOTORCYCLE/SCOOTER/MOPED/CYCLE ADVANCE
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File1} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>

              <tr>
                <td>
                  <span>2</span>
                </td>
                <td>
                  <strong>
                  APPLICATION FORM FOR WHEAT ADVANCE 
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File2} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>

              <tr>
                <td>
                  <span>3</span>
                </td>
                <td>
                  <strong>
                  APPLICATION FORM FOR HOUSE BUILDING ADVANCE
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File3} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>
              <tr>
                <td>
                  <span>4</span>
                </td>
                <td>
                  <strong>
                  APPLICATION FORM FOR MARRIAGE ADVANCE
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File4} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>
              <tr>
                <td>
                  <span>5</span>
                </td>
                <td>
                  <strong>
                  APPLICATION FORM FOR COMPUTER ADVANCE
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File5} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>
              <tr>
                <td>
                  <span>6</span>
                </td>
                <td>
                  <strong>
                  APPLICATION FORM FOR EDUCATION ALLOWANCE
                  </strong>
                </td>
                
                <td className="text-center align-middle">
                  <Link to={File6} target="_blank">
                    <FaFilePdf style={{ fontSize: "25px" }} />{" "}
                  </Link>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
    </div>
    </div>
  )
}

export default Forms
